import { Text, TextAppearance, TextColor, BreakpointWrapper, Breakpoints } from '@volkswagen-onehub/components-core';
import React from 'react';
import { AppInfinite } from '../InfiniteLights.js';
import { options } from '../options';
import { styled } from '@volkswagen-onehub/components-core';
import { LatinoBlackTitle } from '../Texts';

const Div = styled.div`
  width: 100%;
  height: var(--100vh);
  background-color: #000000;

  & canvas {
    width: 100%;
    height: 100%;
  }
`;

const TextWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  text-align: center;
  max-width: 1920px;

  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  @media screen and (min-width: 1280px) {
    gap: 32px;
  }
  @media screen and (min-width: 1600px) {
    gap: 52px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 var(--size-grid001); 
  
`;
const BodyWrapper = styled.div`
  width: 100%;
  padding: 0 var(--size-grid001);
`;

export function FirstSlide({ loadAnimation }: { loadAnimation: boolean }) {
  const divRef = React.useRef(null);
  const destroyAnimation = () => {
    const canvas = document.getElementsByTagName('canvas')[0];
    if (!canvas) return;
    canvas.remove();
  };
  const startAnimation = () => {
   const app = new AppInfinite(divRef.current, options);
   app.loadAssets().then(app.init);
  };
  React.useEffect(() => {
    if (divRef.current) {
      if (loadAnimation) {
        startAnimation();
      } else {
        destroyAnimation();
      }
    }
  }, [loadAnimation]);

  return (
    <div style={{ position: 'relative' }}>
      <Div ref={divRef} />
      <TextWrapper className="title-wrapper">
        <BreakpointWrapper max={Breakpoints.b960}>
          <Title />
          <BodyMobile />
        </BreakpointWrapper>
        <BreakpointWrapper min={Breakpoints.b960}>
          <Title />
          <BodyDesktop />
        </BreakpointWrapper>
      </TextWrapper>
    </div>
  );
}

const Title = () => {
  // hasta 959px, si intentamos replicar los saltos de línea de diseño la tipo que muy pequeña
  return (
    <TitleWrapper className="title">
      <LatinoBlackTitle>Así que</LatinoBlackTitle>
      <LatinoBlackTitle>te atreves a</LatinoBlackTitle>
      <LatinoBlackTitle>ir a contracorriente, ¿eh?</LatinoBlackTitle>
    </TitleWrapper>
  );
};

const BodyMobile = () => {
  // hasta 959px, si intentamos replicar los saltos de línea de diseño la tipo que muy pequeña
  
  return (
    <BodyWrapper>
      <Text appearance={TextAppearance.copy0200} color={TextColor.inherit}>
          Lánzate un día a la aventura al volante de un coupé. Y al otro, derrocha elegancia con un SUV que combina estilo y personalidad. {' '}
          Con el<Text bold> Nuevo Taigo</Text>, el primer  SUV  coupé de Volkswagen, puedes tenerlo todo.{' '}
        <Text bold>
          <span style={{ whiteSpace: 'nowrap' }}>Sé infiel a lo común o... ¿te lo vas a perder?</span>
        </Text>
      </Text>
    </BodyWrapper>
  );
};

const BodyDesktop = () => {
  // a partir de 960px para posicionar los saltos de línea según diseño
  return (
    <>
      <BreakpointWrapper max={Breakpoints.b1280}>
        <BodyWrapper>
          <Text appearance={TextAppearance.copy0250} color={TextColor.inherit}>
            Lánzate un día a la aventura al volante de un coupé. Y al otro, derrocha elegancia con un SUV que combina estilo y personalidad. {' '}
            Con el<Text bold> Nuevo Taigo</Text>, el primer  SUV  coupé de Volkswagen, puedes tenerlo todo.
          </Text>
          <Text appearance={TextAppearance.copy0250} color={TextColor.inherit} bold>
            <span style={{ whiteSpace: 'nowrap' }}>Sé infiel a lo común o... ¿te lo vas a perder?</span>
          </Text>
        </BodyWrapper>
      </BreakpointWrapper>
      <BreakpointWrapper min={Breakpoints.b1280}>
        <BodyWrapper>
          <Text appearance={TextAppearance.copy0300} color={TextColor.inherit}>
            Lánzate un día a la aventura al volante de un coupé. Y al otro, derrocha elegancia con un SUV que combina estilo y personalidad. {' '}
            Con el<Text bold> Nuevo Taigo</Text>, el primer  SUV  coupé de Volkswagen, puedes tenerlo todo.
          </Text>
          <Text appearance={TextAppearance.copy0300} color={TextColor.inherit} bold>
            <span style={{ whiteSpace: 'nowrap' }}>Sé infiel a lo común o... ¿te lo vas a perder?</span>
          </Text>
        </BodyWrapper>
      </BreakpointWrapper>
    </>
  );
};
